import PropTypes from 'prop-types'
import React from 'react'
import styles from './index.module.scss'
import Img from '../Img'
import H2 from '../Headings/H2'

const TitleImage = ({ img, text, TitleComponent }) => (
  <div className="relative mx-auto max-w-5xl" id="title-image">
    <Img
      src={img}
      alt={text}
      objectFit="cover"
      dataTestId="hero-image"
      className="m-auto h-46 w-full md:block md:h-50"
      priority={true}
    />
    <div
      className={`absolute inset-0 m-auto md:ml-12 ${styles.Title} md:inset-y-0 md:left-0 md:right-auto`}
      data-testid="hero-text"
    >
      <TitleComponent
        text={text}
        id={text}
        className="mb-2 mt-8 bg-gray-50 p-2 text-center text-3xl text-blue-600 md:p-8 md:text-4xl"
      />
    </div>
  </div>
)

TitleImage.defaultProps = {
  img: ' ',
  text: '',
  TitleComponent: H2,
}

TitleImage.propTypes = {
  img: PropTypes.string,
  text: PropTypes.string,
  TitleComponent: PropTypes.elementType,
}

export default React.memo(TitleImage)
